const promiseProgress = (proms: any, cb: any) => {
  let d = 0;
  cb(0);
  for (const p of proms) {
    p.then(() => {
      d++;
      cb((d * 100) / proms.length);
    });
  }
  return Promise.all(proms);
};

export default promiseProgress;
